import { render, staticRenderFns } from "./Myorderdsm.vue?vue&type=template&id=5e7e7d9e&scoped=true&"
import script from "./Myorderdsm.vue?vue&type=script&lang=js&"
export * from "./Myorderdsm.vue?vue&type=script&lang=js&"
import style0 from "./Myorderdsm.vue?vue&type=style&index=0&id=5e7e7d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7e7d9e",
  null
  
)

export default component.exports